var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 10.8333C7.96032 10.8333 8.33341 10.4602 8.33341 9.99999C8.33341 9.53975 7.96032 9.16666 7.50008 9.16666C7.03984 9.16666 6.66675 9.53975 6.66675 9.99999C6.66675 10.4602 7.03984 10.8333 7.50008 10.8333Z",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 10.8333C12.9603 10.8333 13.3334 10.4602 13.3334 9.99999C13.3334 9.53975 12.9603 9.16666 12.5001 9.16666C12.0398 9.16666 11.6667 9.53975 11.6667 9.99999C11.6667 10.4602 12.0398 10.8333 12.5001 10.8333Z",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.25C9.16667 5.41667 10.8333 5.41667 13.75 6.25",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 13.75C8.74992 14.5833 11.2499 14.5833 14.1666 13.75",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 14.1667C12.9167 15 14.1667 16.6667 14.5834 16.6667C15.8334 16.6667 16.9442 15.2775 17.5001 14.1667C18.0559 12.7775 17.9167 9.30584 16.2501 4.58334C15.0359 3.73751 13.7501 3.46668 12.5001 3.33334L11.6667 5.41668",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08343 14.1667C7.08343 15 5.95343 16.6667 5.55676 16.6667C4.36593 16.6667 3.30843 15.2775 2.77926 14.1667C2.25009 12.7775 2.38259 9.30584 3.96926 4.58334C5.12593 3.73751 6.28759 3.46668 7.50009 3.33334L8.33343 5.41668",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/Discord.76aefb3221fa0d15810f8e263ad59455.svg";
export { ForwardRef as ReactComponent };